import { createSlice } from '@reduxjs/toolkit';
import { membersApi } from '@store/rtk/members';
import { TableData } from '@uikit/Tables/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type PreferencesSliceType = {
  preferencesData: TableData;
};

const { preferenceColumns } = TABLE_COLUMNS;

const initialState: PreferencesSliceType = {
  preferencesData: {
    columns: preferenceColumns,
    rows: [],
  },
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    // Define your reducers here
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      membersApi.endpoints.getPreferences.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.preferencesData = {
            ...state.preferencesData,
            rows: [
              ...payload.content.map((el) => ({
                ...el,
              })),
            ],
            ...payload,
            requestTablePageChange: membersApi.endpoints.getPreferences,
            filter: payload.filter || {},
          };
        }
      }
    );
  },
});

export const selectPreferences = (state: {
  preferences: PreferencesSliceType;
}) => state.preferences;
export const preferencesReducer = preferencesSlice.reducer;
